const BILLING_SERVICE_BASE = "/gateway/api/billing"

export const API_NINETICK_PLANS = `${BILLING_SERVICE_BASE}/plans`
export const API_NINETICK_ORDER = `${BILLING_SERVICE_BASE}/ninetick/orders`
export const API_NINETICK_TRANSACTIONS = `${BILLING_SERVICE_BASE}/transactions`
